import { Skeleton, Stack } from '@mui/material';

export function ProductMasterSkeletons() {
	return (
		<Stack gap={3}>
			{/* Toolbar */}
			<Stack
				direction="row"
				alignItems="center"
				gap={2}
				flexWrap="wrap"
				sx={{ marginBottom: '10px' }}
			>
				{/* Fila 1 */}
				<Stack
					direction={{ xs: 'column', sm: 'row' }}
					alignItems={{ xs: 'flex-start', sm: 'center' }}
					justifyContent="space-between"
					sx={{ width: '100%', gap: 2 }}
					gap={2}
					flexWrap="wrap"
				>
					{/* Labels and Filters */}
					<Stack
						direction="row"
						alignItems="center"
						gap={2}
						flexWrap="wrap"
						sx={{ minHeight: '40px' }}
					>
						{/* Labels */}
						<Stack
							direction="row"
							alignItems="center"
							gap={2}
							flexWrap="wrap"
							sx={{ minHeight: '40px' }}
						>
							<Skeleton
								variant="rectangular"
								width={300}
								height={60}
								sx={{
									borderRadius: '5px',
								}}
							/>
							<Skeleton
								variant="rectangular"
								width={190}
								height={60}
								sx={{
									borderRadius: '5px',
								}}
							/>

							<Skeleton
								variant="rectangular"
								width={190}
								height={60}
								sx={{
									borderRadius: '5px',
								}}
							/>
							<Skeleton
								variant="rectangular"
								width={190}
								height={60}
								sx={{
									borderRadius: '5px',
								}}
							/>
						</Stack>
					</Stack>
				</Stack>
				{/* Fila 2 */}
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="flex-start"
					sx={{ width: '100%' }}
					gap={2}
					flexWrap="wrap"
				>
					<Skeleton
						variant="rectangular"
						width={65}
						height={50}
						sx={{
							borderRadius: '5px',
						}}
					/>
					<Skeleton
						variant="rectangular"
						width={65}
						height={50}
						sx={{
							borderRadius: '5px',
						}}
					/>
				</Stack>
				{/* Fila 3 */}
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="flex-start"
					sx={{ width: '100%' }}
					gap={4}
					flexWrap="wrap"
				>
					<Skeleton
						variant="rectangular"
						width={320}
						height={100}
						sx={{
							borderRadius: '5px',
						}}
					/>
					<Skeleton
						variant="rectangular"
						width={320}
						height={100}
						sx={{
							borderRadius: '5px',
						}}
					/>
					<Skeleton
						variant="rectangular"
						width={320}
						height={100}
						sx={{
							borderRadius: '5px',
						}}
					/>
					<Skeleton
						variant="rectangular"
						width={320}
						height={100}
						sx={{
							borderRadius: '5px',
						}}
					/>
				</Stack>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="flex-start"
					sx={{ width: '100%' }}
					gap={2}
					flexWrap="wrap"
				>
					<Skeleton
						variant="rectangular"
						width={150}
						height={30}
						sx={{
							borderRadius: '5px',
						}}
					/>
					<Skeleton
						variant="rectangular"
						width={70}
						height={30}
						sx={{
							borderRadius: '5px',
						}}
					/>
					<Skeleton
						variant="rectangular"
						width={110}
						height={30}
						sx={{
							borderRadius: '5px',
						}}
					/>
				</Stack>
			</Stack>

			<Skeleton
				variant="rectangular"
				width="100%"
				height={620}
				sx={{
					borderRadius: '5px',
					zIndex: 1,
				}}
			/>
		</Stack>
	);
}
